const CryptoJS = require('crypto-js');

export function decrypt(ciphertext) {
  const secretKey = process.env.REACT_APP_SECRET_KEY;

  if (secretKey) {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  }
}
